// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"17020ed6","455":"12c50edb","977":"7e88b4a0"}[chunkId] + ".chunk.js";
};